import { HrmRequestFormResponse } from '@Types/api/form';
import { RequestListSearchResponse } from '@Types/api/requestList';
import { parseDateTime } from '@Utils/transformDateTime';
import { TypeDict } from 'types';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';

import { ColumnDataType } from './types';
import { Languages } from '../languages';

export const dataSourceMap = (
  data: RequestListSearchResponse<HrmRequestFormResponse>,
  findStatus: (statusNum: number) => TypeDict | undefined,
  findLeaveType: (statusNum: number) => TypeDict | undefined
): Array<ColumnDataType> => {
  if (!data?.content) return [];

  return data?.content?.map((requestItem) => ({
    key: requestItem.requestId,
    empName: requestItem.empName,
    approverName: requestItem.approverName,
    requestNo: requestItem.requestId,
    leaveType: findLeaveType(requestItem.leaveTypeID)?.codeDesc || '',
    remarks: requestItem.remarks || EMPTY_FIELD_PLACEHOLDER,
    startDate: parseDateTime(requestItem.startDate),
    destination: Languages[requestItem.destination as keyof typeof Languages],
    status: findStatus(requestItem.reqStatusId)?.codeDesc || '',
    action: '',
  }));
};
